<template>
  <div
    :id="id"
    class="modal-field-library"
  >
    <div class="modal-field-title">ICONS</div>

    <div class="modal-field-content">
      <!-- Input Search -->
      <div class="input-search">
        <i class="fa fa-search" />
        <input
          v-model="searchIcon"
          type="text"
          placeholder="Search"
        >
      </div>

      <!-- Icon List -->
      <div class="wrap-field">
        <div class="icon-list">
          <div
            v-for="(icon, index) in icons"
            :key="index"
            class="list"
            @click="$emit('select-icon', icon)"
          >
            <i :class="`fa ${icon.facode}`" />
          </div>
        </div>
      </div>
    </div>

    <div class="modal-field-footer">
      <button @click="$emit('close-modal')">Close</button>
    </div>
  </div>
</template>

<script>
import fontawesome from '@/assets/file/fontawesome.json';

export default {
  props: {
    id: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      searchIcon: '',
      masterIcons: fontawesome,
      icons: [],
    };
  },

  watch: {
    searchIcon(val) {
      if (val.length > 0) {
        const dataIcons = this._.cloneDeep(this.masterIcons);
        const filtered = dataIcons.filter(icon => icon.facode.includes(val));
        this.icons = filtered;
      } else {
        this.icons = this.masterIcons;
      }
    },
  },

  created() {
    this.icons = this.masterIcons;
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/popup/ModalIconActionBtn.vue